export default {
  api: "https://extra-bonus.robonomics.network"
};
